import styled from "styled-components"

export default styled.img`
  ${({size = "90px"}) => `
    width: ${size};
    height: ${size};
  `}
`
